'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash.differenceby');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.sortby');

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = require('lodash.deburr');

var _lodash6 = _interopRequireDefault(_lodash5);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var _Icons = require('./Icons');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Select = function (_PureComponent) {
	_inherits(Select, _PureComponent);

	function Select(props) {
		var _this2 = this;

		_classCallCheck(this, Select);

		var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		_this.onChangeDisplayedSearch = function (_ref) {
			var displayedSearch = _ref.value;

			_this.setState({ displayFullDataset: false });
			_this.setState({ displayedSearch: displayedSearch });
			if (_this.props.hasSearch) _this.setState({ search: displayedSearch });
		};

		_this.onChangeSelectNative = function (_ref2) {
			var value = _ref2.target.value;
			return _this.onChange(value);
		};

		_this.componentWillUnmount = function () {
			_this.removeButtonListeners();
			document.removeEventListener("click", _this.onClickDocumentEvent);
			_this.closeMenuOptions(true);
		};

		_this.getItemFromValue = function (value) {
			var dataset = _this.props.dataset;

			if (value === "") {
				return { value: "", label: "" };
			}
			var ob = dataset.find(function (d) {
				return d && d.value.toString() === value.toString();
			});
			if (!ob) {
				console.error("[Select] Value", value, "not found in dataset"); // eslint-disable-line
				return {};
			}
			return ob;
		};

		_this.getItemFromLabel = function (label) {
			var dataset = _this.props.dataset;


			if (label === "") return null;
			var ob = dataset.find(function (d) {
				return typeof d.label === "string" && d.label.toLowerCase() === label.toLowerCase();
			}) || null;
			return ob;
		};

		_this.componentDidUpdate = function (oldProps) {
			var datasetDiff = (0, _lodash2.default)(_this.props.dataset, oldProps.dataset, 'value');
			if (oldProps.value !== _this.props.value || datasetDiff.length > 0) {
				_this.setState({
					search: _this.getItemFromValue(_this.props.value).label,
					displayedSearch: _this.getItemFromValue(_this.props.value).label
				});
			}
		};

		_this.onClickChange = function (value) {
			return function () {
				return _this.onChange(value);
			};
		};

		_this.onChange = function (value) {
			var _this$props = _this.props,
			    onChange = _this$props.onChange,
			    removeSearchOnClick = _this$props.removeSearchOnClick,
			    closeOnChange = _this$props.closeOnChange,
			    isMultiple = _this$props.isMultiple;

			if (closeOnChange) _this.closeMenuOptions();
			var ob = _this.getItemFromValue(value);
			if (!isMultiple) _this.setState({ search: removeSearchOnClick ? '' : ob.label, displayedSearch: removeSearchOnClick ? '' : ob.label });
			onChange(_extends({ type: "select" }, ob));
			return value;
		};

		_this.onFocusSearch = function () {
			var onFocus = _this.props.onFocus;

			_this.setState({ focus: true });
			if (!_this.state.hasBeenFocused) _this.setState({ hasBeenFocused: true });
			_this.setState({ displayFullDataset: true });
			if (onFocus) onFocus();
			_this.openMenuOptions();
		};

		_this.onBlurSearch = function () {
			var _this$props2 = _this.props,
			    onBlur = _this$props2.onBlur,
			    closeOnBlur = _this$props2.closeOnBlur;

			if (closeOnBlur) setTimeout(_this.closeMenuOptions, 250);
			if (onBlur) onBlur();
		};

		_this.openMenuOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
			var value, deployed, displayedDataset, index, list, selected;
			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							value = _this.props.value;
							deployed = _this.state.deployed;

							if (!deployed) {
								_context.next = 4;
								break;
							}

							return _context.abrupt('return');

						case 4:
							displayedDataset = _this.getDisplayDataset();

							if (!_this.props.useNative) {
								_context.next = 7;
								break;
							}

							return _context.abrupt('return');

						case 7:
							_context.next = 9;
							return _this.setState({ deployed: true, renderOptions: true });

						case 9:
							if (_this.timerReploy) clearTimeout(_this.timerReploy);
							if (!_this.dom) _this.dom = _this.ref.current;

							if (!(value && value !== "")) {
								_context.next = 18;
								break;
							}

							index = displayedDataset.findIndex(function (search) {
								return search.value === value;
							});
							list = _this.selectOptionList;

							if (list) {
								_context.next = 16;
								break;
							}

							return _context.abrupt('return');

						case 16:
							selected = list.getElementsByTagName("li")[index];

							if (selected.offsetTop + selected.clientHeight > list.clientHeight) list.scrollTop = selected.clientHeight * index;

						case 18:
							document.addEventListener("click", _this.onClickDocumentEvent);

						case 19:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this2);
		}));

		_this.closeMenuOptions = function () {
			var instant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
			var useNative = _this.props.useNative;
			var deployed = _this.state.deployed;

			_this.setState({ focus: false });
			if (!deployed || useNative) return;

			_this.setState({ deployed: false });
			if (instant) _this.setState({ renderOptions: false });
			document.removeEventListener("click", _this.onClickDocumentEvent);
			_this.removeButtonListeners();
			_this.timerReploy = setTimeout(function () {
				_this.setState({ renderOptions: false });
			}, 300);
		};

		_this.addButtonListener = function () {
			window.addEventListener("keydown", _this.onDocumentKeyPressed);
		};

		_this.removeButtonListeners = function () {
			window.removeEventListener("keydown", _this.onDocumentKeyPressed);
		};

		_this.onDocumentKeyPressed = function (e) {
			e.preventDefault();
			_this.onKeyPress({ key: e.key, keyCode: e.keyCode, event: e });
		};

		_this.onClickButton = function () {
			_this.setState({ hasBeenFocused: true, focus: true });
			if (_this.state.deployed) _this.closeMenuOptions();else {
				_this.openMenuOptions();
				_this.addButtonListener();
			}
		};

		_this.onKeyPress = function (event) {
			var _this$state = _this.state,
			    displayedSearch = _this$state.displayedSearch,
			    deployed = _this$state.deployed;
			var _this$props3 = _this.props,
			    value = _this$props3.value,
			    onFocusOut = _this$props3.onFocusOut;

			var displayedDataset = _this.getDisplayDataset();
			var index = displayedDataset.findIndex(function (search) {
				return search.label === displayedSearch;
			});
			var input = _this.input;
			switch (event.key) {
				case 'Tab':
					{
						// TAB
						var hasBeenSelected = _this.onEnterPress();
						if (_this.props.onTabPressed) _this.props.onTabPressed({ event: event, value: hasBeenSelected });
						break;
					}
				case 'Escape':
					{
						// ESC
						var label = _this.getItemFromValue(value).label;
						_this.setState({ search: label, displayedSearch: label });
						if (onFocusOut) onFocusOut();
						_this.closeMenuOptions();
						if (displayedSearch === '') {
							_this.onChange("");
						}
						break;
					}
				case 'ArrowDown':
					{
						// DOWN ARROW
						var selectDown = index > -1 && index < displayedDataset.length - 1 ? index + 1 : 0;
						_this.setState({ displayedSearch: displayedDataset[selectDown].label });
						_this.openMenuOptions();
						if (deployed) {
							var list = _this.selectOptionList;
							if (!list) return;
							var selected = list.getElementsByTagName("li")[selectDown];
							if (selectDown === 0) {
								list.scrollTop = 0;
							}
							// if the selected item is off screen, scroll down
							if (selected.offsetTop + selected.clientHeight >= list.clientHeight + list.scrollTop) {
								list.scrollTop += selected.clientHeight;
							}
						}
						break;
					}
				case 'ArrowUp':
					{
						// UP ARROW
						_this.openMenuOptions();
						event.event.preventDefault(); // set caret position to the end
						if (input && input.value) input.setSelectionRange(input.value.length, input.value.length);
						var selectUp = index > 0 ? index - 1 : displayedDataset.length - 1;
						_this.setState({ displayedSearch: displayedDataset[selectUp].label });
						if (deployed) {
							var _list = _this.selectOptionList;
							if (!_list) return;
							var _selected = _list.getElementsByTagName("li")[selectUp];
							if (selectUp === displayedDataset.length - 1) {
								_list.scrollTop = _selected.clientHeight * displayedDataset.length;
							}
							// if the selected item is off screen, scroll up
							else if (_selected.offsetTop < _list.scrollTop) {
									_list.scrollTop -= _selected.clientHeight;
								}
						}
						break;
					}
				case 'Enter':
					_this.onEnterPress();
					break;
				default:
					_this.openMenuOptions();
			}
		};

		_this.onClickDocumentEvent = function (e) {
			e.preventDefault();
			var _this$props4 = _this.props,
			    value = _this$props4.value,
			    onFocusOut = _this$props4.onFocusOut;
			// Click outside component

			if ((0, _utils.isEventOutside)(e, _this.dom)) {
				// We remove search and reinitialize displayed value
				_this.setState({ search: '', displayedSearch: _this.getItemFromValue(value).label });
				if (onFocusOut) onFocusOut();
				_this.closeMenuOptions();
			}
		};

		_this.getDisplayDataset = function () {
			var _this$props5 = _this.props,
			    dataset = _this$props5.dataset,
			    pinned = _this$props5.pinned,
			    maxListItems = _this$props5.maxListItems,
			    useNative = _this$props5.useNative,
			    sort = _this$props5.sort,
			    selected = _this$props5.selected,
			    hasSearch = _this$props5.hasSearch;
			var displayedSearch = _this.state.displayedSearch;
			var _this$state2 = _this.state,
			    search = _this$state2.search,
			    displayFullDataset = _this$state2.displayFullDataset;


			var selectedItems = dataset.map(function (d) {
				return _extends({}, d, { selected: displayedSearch === d.label || selected.findIndex(function (p) {
						return p === d.value;
					}) > -1 });
			});
			var sorted = sort ? (0, _lodash4.default)(selectedItems, [function (_ref4) {
				var label = _ref4.label;
				return (0, _lodash6.default)(label);
			}]) : selectedItems;
			var withPins = [].concat(_toConsumableArray(pinned.map(function (pin) {
				return _extends({ pinned: true }, sorted.find(function (d) {
					return d.value === pin;
				}));
			})), _toConsumableArray(sorted.filter(function (s) {
				return pinned.findIndex(function (p) {
					return p === s.value;
				}) === -1;
			})));
			if (displayFullDataset) return withPins;
			var filtered = !useNative && hasSearch ? withPins.filter(function (v) {
				return (0, _lodash6.default)(v.label.toLowerCase()).indexOf((0, _lodash6.default)(search.toLowerCase())) > -1;
			}) : withPins;
			return filtered.slice(0, maxListItems > -1 && !useNative && hasSearch ? maxListItems : filtered.length);
		};

		_this.onEnterPress = function () {
			var _this$state3 = _this.state,
			    displayedSearch = _this$state3.displayedSearch,
			    search = _this$state3.search;


			_this.setState({ search: displayedSearch });
			var ob = _this.getItemFromLabel(displayedSearch);
			// Label matches an item > we select it
			if (ob) return _this.onChange(ob.value);

			// If a search exists
			if (search === "") {
				_this.setState({ search: '', displayedSearch: '' });
				return _this.onChange("");
			}

			// we select first item in datalist
			var ds = _this.getDisplayDataset();
			if (ds.length > 0) return _this.onChange(ds[0].value);
			// else, we remove the search
			_this.setState({ search: '', displayedSearch: '' });
			return '';
		};

		_this.renderInput = function () {
			var _this$state4 = _this.state,
			    displayedSearch = _this$state4.displayedSearch,
			    hasBeenFocused = _this$state4.hasBeenFocused;
			var _this$props6 = _this.props,
			    required = _this$props6.required,
			    defaultOptionLabel = _this$props6.defaultOptionLabel,
			    value = _this$props6.value,
			    error = _this$props6.error,
			    controlledError = _this$props6.controlledError,
			    shrink = _this$props6.shrink,
			    label = _this$props6.label,
			    labelAsPlaceholder = _this$props6.labelAsPlaceholder;

			var shouldDisplayError = hasBeenFocused && required && (!value || value === "") && (!controlledError || error);

			return _react2.default.createElement(_Input2.default, _extends({
				ref: function ref(node) {
					return _this.input = node;
				}
			}, _this.props, {
				value: shrink || labelAsPlaceholder ? displayedSearch : '',
				onChange: _this.onChangeDisplayedSearch,
				error: shouldDisplayError,
				onKeyPress: _this.onKeyPress,
				required: required,
				useIcons: false,
				errorRequiredText: '',
				className: '',
				label: labelAsPlaceholder ? '' : label,
				onFocus: _this.onFocusSearch,
				placeholder: labelAsPlaceholder ? label : defaultOptionLabel,
				onBlur: _this.onBlurSearch
			}));
		};

		_this.renderButton = function () {
			var _this$state5 = _this.state,
			    displayedSearch = _this$state5.displayedSearch,
			    hasBeenFocused = _this$state5.hasBeenFocused,
			    focus = _this$state5.focus;
			var _this$props7 = _this.props,
			    label = _this$props7.label,
			    defaultOptionLabel = _this$props7.defaultOptionLabel,
			    required = _this$props7.required,
			    disabled = _this$props7.disabled,
			    error = _this$props7.error,
			    value = _this$props7.value,
			    shrink = _this$props7.shrink;


			var hasError = error || hasBeenFocused && required && (!value || value === "") && !focus;

			return _react2.default.createElement(
				'label',
				{ className: (0, _classnames2.default)('bnc_field_button_as_input', {
						'bnc_field_select_button--shrink-label': (focus || defaultOptionLabel !== '' || value && value !== "") && shrink,
						'bnc_field_select_button--has-label': label && label !== '',
						'bnc_field_select_button--disabled': disabled,
						'bnc_field_select_button--error': hasError
					}) },
				label && label !== '' && _react2.default.createElement(
					'span',
					{ className: 'label' },
					label,
					required && _react2.default.createElement(
						'abbr',
						null,
						'*'
					)
				),
				_react2.default.createElement(
					'button',
					{
						onClick: _this.onClickButton,
						disabled: disabled
					},
					shrink && displayedSearch && displayedSearch !== '' ? displayedSearch : defaultOptionLabel || ''
				)
			);
		};

		_this.state = {
			search: _this.getItemFromValue(props.value).label || '',
			displayedSearch: _this.getItemFromValue(props.value).label || '',
			deployed: false,
			displayFullDataset: true,
			renderOptions: false,
			hasBeenFocused: false,
			focus: false
		};

		_this.ref = (0, _react.createRef)();
		return _this;
	}

	_createClass(Select, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    useNative = _props.useNative,
			    className = _props.className,
			    required = _props.required,
			    errorRequiredText = _props.errorRequiredText,
			    value = _props.value,
			    disabled = _props.disabled,
			    size = _props.size,
			    labelAsOption = _props.labelAsOption;
			var _state = this.state,
			    hasBeenFocused = _state.hasBeenFocused,
			    focus = _state.focus;


			return _react2.default.createElement(
				'div',
				{
					ref: this.ref,
					className: (0, _classnames2.default)('bnc_field', 'bnc_field_select', className, 'bnc_field_select--size--' + size, {
						'bnc_field_select--disabled': disabled,
						'bnc_field_select--label-as-option': labelAsOption
					})
				},
				useNative ? this.renderNative() : this.renderEnhanced(),
				hasBeenFocused && !focus && required && (!value || value === "") && errorRequiredText && errorRequiredText !== '' && _react2.default.createElement(
					'span',
					{ className: 'error' },
					errorRequiredText
				)
			);
		}
	}, {
		key: 'renderNative',
		value: function renderNative() {
			var _this3 = this;

			var _props2 = this.props,
			    value = _props2.value,
			    defaultOptionLabel = _props2.defaultOptionLabel,
			    label = _props2.label,
			    required = _props2.required,
			    disabled = _props2.disabled,
			    error = _props2.error,
			    controlledError = _props2.controlledError,
			    shrink = _props2.shrink;
			var _state2 = this.state,
			    hasBeenFocused = _state2.hasBeenFocused,
			    focus = _state2.focus;


			var hasError = error && !controlledError || hasBeenFocused && required && (!value || value === "") && !focus;

			var dataset = this.getDisplayDataset();
			var shouldDisplayError = hasBeenFocused && required && (!value || value === "");
			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)('bnc_field_input', 'bnc_field_select_native', {
						'bnc_field_input--shrink-label': (focus || defaultOptionLabel !== '') && shrink,
						'bnc_field_input--has-label': label && label !== '',
						'bnc_field_input--disabled': disabled,
						'bnc_field_input--error': hasError
					}) },
				_react2.default.createElement(
					'label',
					{ className: shouldDisplayError ? 'is-error' : '' },
					label && label !== '' && _react2.default.createElement(
						'span',
						{ className: 'label' },
						label,
						required && _react2.default.createElement(
							'abbr',
							null,
							'*'
						)
					),
					_react2.default.createElement(
						'select',
						{
							ref: function ref(node) {
								return _this3.input = node;
							},
							value: shrink ? value : '',
							disabled: disabled,
							onChange: this.onChangeSelectNative,
							onFocus: this.onFocusSearch,
							onBlur: this.onBlurSearch
						},
						(!value || value === "") && _react2.default.createElement(
							'option',
							{ value: '', disabled: true },
							defaultOptionLabel
						),
						dataset.map(function (_ref5) {
							var ov = _ref5.value,
							    ol = _ref5.label,
							    od = _ref5.disabled;
							return _react2.default.createElement(
								'option',
								{ key: ov, value: ov, disabled: od },
								ol
							);
						})
					),
					_react2.default.createElement(_Icons.ChevronDown, { className: 'icon icon--rotate' + (label ? " offset-top" : "") })
				)
			);
		}
	}, {
		key: 'renderEnhanced',
		value: function renderEnhanced() {
			var _this4 = this;

			var _state3 = this.state,
			    deployed = _state3.deployed,
			    renderOptions = _state3.renderOptions;
			var hasSearch = this.props.hasSearch;


			return _react2.default.createElement(
				'div',
				{ className: 'bnc_field_select_enhanced' },
				hasSearch ? this.renderInput() : this.renderButton(),
				_react2.default.createElement(_Icons.ChevronDown, { className: (0, _classnames2.default)('icon', {
						'icon--rotate--180': deployed
					})
				}),
				_react2.default.createElement(
					'div',
					{ className: 'bnc_field_select_options' },
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)('bnc_field_select_options_mask', {
								'deployed': deployed,
								'rendered': renderOptions
							})
						},
						_react2.default.createElement(
							'div',
							{ className: 'bnc_field_select_options_list', ref: function ref(node) {
									return _this4.selectOptionList = node;
								} },
							renderOptions && this.renderEnchancedOptions()
						)
					)
				)
			);
		}
	}, {
		key: 'renderEnchancedOptions',
		value: function renderEnchancedOptions() {
			var _this5 = this;

			var dataset = this.getDisplayDataset();

			return _react2.default.createElement(
				'ul',
				null,
				dataset.map(function (_ref6) {
					var ov = _ref6.value,
					    ol = _ref6.label,
					    react = _ref6.react,
					    disabled = _ref6.disabled,
					    icon = _ref6.icon,
					    pinned = _ref6.pinned,
					    selected = _ref6.selected;
					return _react2.default.createElement(
						'li',
						{
							key: ov,
							value: ov,
							className: (0, _classnames2.default)({
								pinned: pinned,
								selected: selected,
								disabled: disabled
							}),
							role: 'option',
							disabled: disabled,
							'aria-selected': selected || false,
							onClick: disabled ? null : _this5.onClickChange(ov)
						},
						react || _react2.default.createElement(
							_react.Fragment,
							null,
							icon,
							' ',
							ol
						)
					);
				})
			);
		}
	}]);

	return Select;
}(_react.PureComponent);

Select.defaultProps = {
	hasSearch: true,
	useNative: false,
	maxListItems: -1,
	disabled: false,
	required: false,
	errorRequiredText: '',
	label: '',
	defaultOptionLabel: '',
	className: '',
	sort: true,
	pinned: [],
	selected: [],
	removeSearchOnClick: false,
	onBlur: null,
	onFocus: null,
	controlledError: false,
	error: false,
	onTabPressed: null,
	size: "regular",
	closeOnChange: true,
	onFocusOut: null,
	shrink: true,
	labelAsOption: false,
	labelAsPlaceholder: false,
	closeOnBlur: true,
	isMultiple: false
};

Select.propTypes = {
	value: _utils.StringOrNumber.isRequired,
	hasSearch: _propTypes2.default.bool,
	dataset: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		value: _utils.StringOrNumber.isRequired,
		label: _utils.StringOrReact.isRequired,
		react: _utils.StringOrReact,
		icon: _propTypes2.default.element,
		selected: _propTypes2.default.bool,
		disabled: _propTypes2.default.bool
	})).isRequired,
	onChange: _propTypes2.default.func,
	pinned: _propTypes2.default.arrayOf(_utils.StringOrNumber),
	selected: _propTypes2.default.arrayOf(_utils.StringOrNumber),
	useNative: _propTypes2.default.bool,
	maxListItems: _propTypes2.default.number,
	disabled: _propTypes2.default.bool,
	required: _propTypes2.default.bool,
	errorRequiredText: _utils.StringOrReact,
	label: _utils.StringOrReact,
	defaultOptionLabel: _propTypes2.default.string,
	className: _propTypes2.default.string,
	sort: _propTypes2.default.bool,
	removeSearchOnClick: _propTypes2.default.bool,
	onBlur: _propTypes2.default.func,
	onFocus: _propTypes2.default.func,
	controlledError: _propTypes2.default.bool,
	error: _propTypes2.default.bool,
	onTabPressed: _propTypes2.default.func,
	size: _propTypes2.default.string,
	closeOnChange: _propTypes2.default.bool,
	onFocusOut: _propTypes2.default.func,
	shrink: _propTypes2.default.bool,
	labelAsOption: _propTypes2.default.bool,
	labeAsPlaceholder: _propTypes2.default.bool,
	closeOnBlur: _propTypes2.default.bool,
	isMultiple: _propTypes2.default.bool
};

exports.default = Select;